import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-martin-rader',
  templateUrl: './martin-rader.component.html',
  styleUrls: ['./martin-rader.component.css']
})
export class MartinRaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
